import { render, staticRenderFns } from "./BatteryFull.vue?vue&type=template&id=36c8f5f3&"
import script from "./BatteryFull.vue?vue&type=script&lang=js&"
export * from "./BatteryFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports